import { DrawingTool, DrawingToolType, ShapeConfig } from './drawing-tool';


export class CircleDrawingTool extends DrawingTool {

    protected readonly TOOL_TYPE: DrawingToolType = DrawingToolType.CIRCLE;

    private readonly DEFAULT_CIRCLE_RADIUS = 0.1;

    public addNewShape(shapeX, shapeY, shapeId, color?: string, parameters?: any) {
        const newShape =
            {
                id: this.generateShapeId(shapeId),
                type: this.TOOL_TYPE,

                fill: this.DEFAULT_FILL_COLOR,
                opacity: this.DEFAULT_OPACITY,
                stroke: color || this.strokeColor,
                strokeWidth: this.strokeWidth,

                radius: this.DEFAULT_CIRCLE_RADIUS,
                x: shapeX,
                y: shapeY,
            } as ShapeConfig
        return newShape;
    }

    public onTouchMove(currentShape, currentX, currentY, startX, startY) {

        const dX2 = (currentX - startX) * (currentX - startX)
        const dY2 = (currentY - startY) * (currentY - startY)

        currentShape.radius = Math.sqrt(dX2 + dY2);

    }

    public onTouchEnd(currentShape, endX, endY, startX, startY) {
        this.onTouchMove(currentShape, endX, endY, startX, startY)
    }


    public resetTool() {
        // this method remains empty for this implementation
    }
}